import noop from 'lodash/noop';

export const TEAM_NAME = 'helix';
export const PROJECT_CREATE_APP_NAME = 'project-create';

export const ScreenType = {
	FORM: 'FORM' as const,
	FORM_WITH_PROJECT_TYPE_DROPDOWN: 'FORM_WITH_PROJECT_TYPE_DROPDOWN' as const,
	ERROR_PAGE: 'ERROR_PAGE' as const,
	CONTAINER_LINKING: 'CONTAINER_LINKING' as const,
	NEW_TEMPLATE_CHOICE: 'NEW_TEMPLATE_CHOICE' as const,
} as const;

export type ScreenTypes = (typeof ScreenType)[keyof typeof ScreenType];

export const PROJECT_CREATE_LOAD_START_MARK_KEY = 'PROJECT_CREATE_LOAD_START_MARK_KEY';
export const PROJECT_CREATE_LOAD_END_MARK_KEY = 'PROJECT_CREATE_LOAD_END_MARK_KEY';
export const PROJECT_CREATE_READY_MARK_KEY = 'PROJECT_CREATE_READY_MARK_KEY';

export const PROJECT_CREATE_JWM_ONBOARDING = 'projectCreateJwmOnboarding';

export const NTH_PROJECT_CREATE = 'nthProjectCreate';

export const defaultProps = {
	isImportProjectOpenInitially: false,
	isTemplatePickerOpenInitially: false,
	isJswOnboarding: false,
	isOnboarding: false,
	isConnectedProjectScenario: false,
	isJiraCoreOnboarding: false,
	skipTemplateSelection: false,
	recommendedTemplate: undefined,
	defaultSelectedTemplateKey: '',
	source: '',
	selectedProjectType: null,
	onPermissionsFetched: noop,
	onDrawerClose: noop,
	onCreateStarted: noop,
	isBusinessUser: false,
} as const;
